import React from "react";
import {
  HeaderContainer,
  Logo,
  LanguageButton,
  ButtonsContainer,
} from "./header.styles";

import { useAppDispatch, useAppSelector } from "utils/hooks";
import { selectFormLanguage } from "redux/form/form.selector";
import { updateFormLanguage } from "redux/form/form.reducer";
import { selectIsFormDisabled } from "redux/helpers/helpers.selector";

const Header: React.FC = () => {
  const dispatch = useAppDispatch();
  const formLanguage = useAppSelector(selectFormLanguage);
  const isFormDisabled = useAppSelector(selectIsFormDisabled);

  return (
    <HeaderContainer id="header">
      {formLanguage === "en" ? (
        <a
          className="logo-link"
          href={process.env.REACT_APP_MAIN_WEBSITE_URL_EN}
          rel="noreferrer"
          target="_blank"
        >
          <Logo src={process.env.REACT_APP_HEADER_LOGO_EN} alt="Logo" />
        </a>
      ) : (
        <a
          href={process.env.REACT_APP_MAIN_WEBSITE_URL_FR}
          rel="noreferrer"
          target="_blank"
        >
          <Logo src={process.env.REACT_APP_HEADER_LOGO_FR} alt="Logo" />
        </a>
      )}
      <ButtonsContainer data-cy="languageButtons">
        <LanguageButton
          currentLang={formLanguage === "en"}
          onClick={() => {
            dispatch(updateFormLanguage("en"));
          }}
          disabled={isFormDisabled}
        >
          EN
        </LanguageButton>{" "}
        /{" "}
        <LanguageButton
          currentLang={formLanguage === "fr"}
          onClick={() => {
            dispatch(updateFormLanguage("fr"));
          }}
          disabled={isFormDisabled}
        >
          FR
        </LanguageButton>
      </ButtonsContainer>
    </HeaderContainer>
  );
};

export default Header;
